module.exports = __webpack_public_path__ + "img/map_Z3.3.A.01.cf590355.svg";